module.exports = __webpack_public_path__ + "static/img/logo.8e48a62e.png";